export const PAGE_NODE_INDEX = 2;
export const PLUGINS_KEY = 'plugins';
